// /opt/ptg01-v1/front-admin/components/DashboardContent.tsx
// Tableau de bord d'accueil — gabarit A (CONVENTIONS.md § 6) : col 1 simulations récentes,
// header compteurs, col 2 tendance, col 3 détail de la simulation sélectionnée.
// Données de démonstration : aucun endpoint KPI business n'est exposé à ce jour.
'use client';

import React, { useState } from 'react';
import { TrendingUp, CheckCircle2, Coins, LayoutDashboard, Activity, XCircle } from 'lucide-react';
import SplitView from './SplitView';
import PageHeader from './PageHeader';
import KpiCard from './KpiCard';
import { AdminCard, DetailRow } from './AdminCard';

type Simulation = { id: string; date: string; ip: string; totalCost: string; netSalary: string; status: 'OK' | 'ERROR' };

const MOCK_SIMULATIONS: Simulation[] = [
    { id: 'sim_1', date: '2026-04-18 12:21', ip: '192.168.1.15', totalCost: '4 071,38 €', netSalary: '2 352,85 €', status: 'OK' },
    { id: 'sim_2', date: '2026-04-18 12:15', ip: '192.168.1.15', totalCost: '3 500,00 €', netSalary: '2 015,40 €', status: 'OK' },
    { id: 'sim_3', date: '2026-04-18 12:10', ip: '10.0.0.5', totalCost: '0,00 €', netSalary: '0,00 €', status: 'ERROR' },
];

export default function DashboardContent() {
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const simulations = MOCK_SIMULATIONS;
    const selected = simulations.find(s => s.id === selectedId) || simulations[0] || null;

    return (
        <SplitView
            list={
                <>
                    <div className="px-4 py-3 border-b border-slate-200">
                        <div className="text-[13px] font-bold text-slate-900">Simulations récentes</div>
                        <div className="text-[11px] text-slate-600 mt-0.5">{simulations.length} simulations · données de démonstration</div>
                    </div>
                    <div className="flex-1 overflow-y-auto">
                        {simulations.map(sim => {
                            const active = selected?.id === sim.id;
                            return (
                                <button key={sim.id} onClick={() => setSelectedId(sim.id)}
                                    className={`w-full text-left px-4 py-2.5 border-b border-slate-100 transition-colors ${active ? 'bg-[#000091]/[0.04] border-l-2 border-l-[#000091]' : 'hover:bg-[#000091]/[0.02]'}`}>
                                    <div className="flex items-center gap-2 mb-1">
                                        {sim.status === 'OK' ? <CheckCircle2 className="w-3.5 h-3.5 text-green-700" /> : <XCircle className="w-3.5 h-3.5 text-rose-600" />}
                                        <span className="text-[12px] font-semibold text-slate-900 truncate flex-1">{sim.date}</span>
                                        <span className="font-mono text-[10px] text-slate-600">{sim.ip}</span>
                                    </div>
                                    <div className="text-[11px] tabular-nums text-slate-600">Net {sim.netSalary} · coût {sim.totalCost}</div>
                                </button>
                            );
                        })}
                    </div>
                </>
            }
            pageHeader={
                <PageHeader
                    icon={<LayoutDashboard className="w-4 h-4 text-[#000091]" />}
                    title="Tableau de bord"
                    subtitle="Vue d'ensemble — KPI business Nexvia Portage · données de démonstration en attendant les endpoints"
                    cols={4}
                    kpis={
                        <>
                            <KpiCard label="Simulations" value={1245} icon={<TrendingUp className="w-3 h-3" />} suffix="+12 % / 7 j" />
                            <KpiCard label="Taux de succès" value="98,5 %" icon={<CheckCircle2 className="w-3 h-3" />} color="green" />
                            <KpiCard label="Salaire net moyen" value="2 450 €" icon={<Coins className="w-3 h-3" />} suffix="+5 % / mois" />
                            <KpiCard label="Erreurs" value={simulations.filter(s => s.status === 'ERROR').length} icon={<Activity className="w-3 h-3" />} color={simulations.some(s => s.status === 'ERROR') ? 'red' : 'default'} />
                        </>
                    }
                />
            }
            col2={
                <div className="p-4 space-y-4">
                    <AdminCard title="Tendance des simulations · 30 jours" icon={<TrendingUp className="w-3 h-3" />}>
                        <div className="p-4">
                            <div className="h-64 rounded-xl border-2 border-dashed border-slate-200 bg-slate-50 flex items-center justify-center text-[12px] text-slate-600">
                                Visualisation à brancher (aucune série exposée par l’API)
                            </div>
                        </div>
                    </AdminCard>
                </div>
            }
            col3={
                <div className="p-4 space-y-4">
                    {selected && (
                        <AdminCard title={`Simulation ${selected.id}`} icon={<Activity className="w-3 h-3" />} right={selected.date} bodyClass="divide-y divide-[#000091]/10">
                            <DetailRow label="Statut" value={
                                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded border ${selected.status === 'OK' ? 'text-green-700 bg-green-50 border-green-200' : 'text-rose-700 bg-rose-50 border-rose-200'}`}>{selected.status}</span>
                            } />
                            <DetailRow label="Date" value={selected.date} />
                            <DetailRow label="Adresse IP" value={selected.ip} mono />
                            <DetailRow label="Coût total" value={selected.totalCost} />
                            <DetailRow label="Salaire net" value={<span className="text-[#000091] font-bold">{selected.netSalary}</span>} />
                        </AdminCard>
                    )}
                </div>
            }
        />
    );
}
